import React, { Component } from 'react';
import { Input } from 'react-materialize';

export default class MetricSelect extends Component {

    onChangeName(event){
        if(this.props.value.name !== event.target.value){
            var metric = this.props.metricList.find(m => m.name === event.target.value);
            var val = {name:event.target.value};
            if(metric){
                val.func = 'sum';
            } else {
                delete val.func;
            }
            val = Object.assign(this.props.value,val);
            this.props.onChange(val);
        }
    }
    onChangeFunc(event){
        if(this.props.value.func !== event.target.value){
            var val = Object.assign(this.props.value,{func:event.target.value});
            this.props.onChange(val);
        }
    }

    render(){
        return <div className="metric-select">
            <h6><b>{this.props.title}</b></h6>
            <Input
                label="Name"
                l={7} m={7} s={7}
                type="select"
                value={this.props.value.name}
                onChange={this.onChangeName.bind(this)}>
                <option value="count">#Transactions</option>
                {this.props.metricList.map((metric,idx) => {
                    return <option key={idx} value={metric.name}>{metric.name}</option>
                })}
            </Input>
            {this.props.value.func &&
                <Input
                    label="Operation"
                    l={5} m={5} s={5}
                    type="select"
                    value={this.props.value.func}
                    onChange={this.onChangeFunc.bind(this)}>
                    <option value="sum">Sum</option>
                    <option value="avg">Average</option>
                    <option value="min">Min</option>
                    <option value="max">Max</option>
                </Input>
            }
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/MetricSelect.jsx